import { render, staticRenderFns } from "./DiseaseListBar.vue?vue&type=template&id=6f4d0aba&scoped=true"
import script from "./DiseaseListBar.vue?vue&type=script&lang=js"
export * from "./DiseaseListBar.vue?vue&type=script&lang=js"
import style0 from "./DiseaseListBar.vue?vue&type=style&index=0&id=6f4d0aba&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4d0aba",
  null
  
)

export default component.exports